export default __webpack_public_path__ + "static/media/logo.7d5819f3.png";